export const NAVBAR_ITEMS = ["about", "skills", "projects", "resume", "contact"];
